import Container from "./components/Container";
import "./output.css";
import "./fonts.css";

function App() {
  return (
    <body className="bg-pale-blue h-screen flex items-center font-HankenGrotesk-Regular">
      <Container />
    </body>
  );
}

export default App;
